import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from '@trackman/web-shared-components';

import { ClassesTableRows } from 'types/organization/organization';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

type Props = {
  rows: ClassesTableRows[];
};

export const StudentsModalTable = observer(({ rows }: Props) => {
  const { t } = useTranslation();
  const cs = useStores().classesStore;

  const handleSelectOne = useCallback(
    (event: React.MouseEvent<unknown>, id: string) => {
      const selectedIndex = cs.studentsToAdd.indexOf(id);
      let newSelected: string[] = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(cs.studentsToAdd, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(cs.studentsToAdd.slice(1));
      } else if (selectedIndex === cs.studentsToAdd.length - 1) {
        newSelected = newSelected.concat(cs.studentsToAdd.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(cs.studentsToAdd.slice(0, selectedIndex), cs.studentsToAdd.slice(selectedIndex + 1));
      }

      cs.studentsToAdd = newSelected;
    },
    [cs]
  );

  return (
    <Table sx={{ minWidth: 750 }} aria-labelledby='studentsTable'>
      <TableHead>
        <TableRow className='sub-table-head-row'>
          <TableCell padding='checkbox'>
            <Checkbox
              color='primary'
              indeterminate={cs.studentsToAdd.length > 0 && cs.studentsToAdd.length < rows.length}
              checked={cs.studentsToAdd.length > 0 && cs.studentsToAdd.length === rows.length}
              onChange={() => (!cs.studentsToAdd.length ? (cs.studentsToAdd = rows.map((n) => n.id)) : (cs.studentsToAdd = []))}
              label={undefined}
            />
          </TableCell>
          <TableCell sx={{ width: 100 }}></TableCell>
          <TableCell sx={{ width: 250 }}>{t('StudentsHeader', { ns: 'studentsPage' })}</TableCell>
          <TableCell sx={{ width: 250 }}></TableCell>
          <TableCell sx={{ width: 250 }}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => {
          const isItemSelected = cs.studentsToAdd.indexOf(row.id) !== -1;

          return (
            <TableRow
              hover
              onClick={(event) => handleSelectOne(event, row.id)}
              role='checkbox'
              aria-checked={isItemSelected}
              key={row.id}
              selected={isItemSelected}
              sx={{ cursor: 'pointer' }}
            >
              <TableCell padding='checkbox'>
                <Checkbox color='primary' checked={isItemSelected} label={undefined} />
              </TableCell>
              <TableCell className='initials-cell' sx={{ width: 100 }}>
                <div>{row.initials}</div>
              </TableCell>
              <TableCell sx={{ width: 250 }}>{row.name}</TableCell>
              <TableCell sx={{ width: 250 }}>{row.classes}</TableCell>
              <TableCell sx={{ width: 250 }}>{row.email}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
});

export default StudentsModalTable;
